export const setActiveBooking = activeBooking => {
  return dispatch => {
    dispatch({
      type: "BOOKINGS_SET_ACTIVE",
      activeBooking
    });
  };
};
